import { useLanguage } from "@/contexts/LanguageContext";
import { TournamentConfig } from "@/services/tournamentService";

interface TournamentAnnouncementProps {
  date?: Date | null;
  timeId?: string;
  tournamentConfig?: TournamentConfig;
}

export const TournamentAnnouncement = ({ tournamentConfig }: TournamentAnnouncementProps) => {
  const { language } = useLanguage();
  
  if (!tournamentConfig) return null;

  const text = language === 'no' ? tournamentConfig.announcementText : tournamentConfig.announcementTextEn;

  return (
    <div className="bg-accent/50 border border-border rounded-lg p-6 my-6">
      <div className="space-y-2 text-foreground whitespace-pre-line">
        {text}
      </div>
    </div>
  );
};